import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';
import {
    Box,
    Grid,
    CardContent,
    Typography,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Paper,
} from "@mui/material";
import { getAuth } from "firebase/auth";


function Selfreport() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchUsers()
        });
    });

    useEffect(() => {
        const loadProperty = async () => {
            const auth = getAuth();
            const user = auth.currentUser;
            if (!user) return;

            const roleSnap = await getDoc(doc(db, "authroles", user.uid));
            if (!roleSnap.exists()) return;

            const pid = roleSnap.data().propertyId;

            const propSnap = await getDoc(doc(db, "properties", pid));
            if (propSnap.exists()) {
                setpropData({ ...propSnap.data() });
            }
        };

        fetchUsers()
        loadProperty();
    }, []);


    const printRef = useRef();
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const [username, setusername] = useState("");
    const [bookingData, setbookingData] = useState([]);
    const [serviceData, setserviceData] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [total, settotal] = useState(0);

    const [allllserviuceamount, setallllserviuceamount] = useState(0)
    const [alladults, setalladults] = useState(0)
    const [allchilds, setallchilds] = useState(0)
    const [allllroomamount, setallllroomamount] = useState(0)
    const [allllfoodamount, setallllfoodamount] = useState(0)
    const [alllltotalamount, setalllltotalamount] = useState(0)
    const [roomscount, setroomscount] = useState(0)
    const [propData, setpropData] = useState({});

    const fetchUsers = async () => {
        try {
            if (!userData || !loadincount) return;

            // --- 1. SETUP DATES & TIME ---
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const tomorrow = new Date(today);
            tomorrow.setDate(tomorrow.getDate() + 1);
            const todayTimestamp = Timestamp.fromDate(today);
            const tomorrowTimestamp = Timestamp.fromDate(tomorrow);
            const reportDate = moment().format('YYYY-MM-DD');

            // --- 2. INITIAL PARALLEL FETCHES (User Data, Pay History, Services) ---
            const userDocRef = doc(db, "authroles", userData.uid);

            const [userDocSnap, payHistorySnapshot, servicesSnapshot] = await Promise.all([
                getDoc(userDocRef),
                getDocs(
                    query(
                        collection(db, "payhistory"),
                        where("uid", "==", userData.uid),
                        where("createdAt", ">=", todayTimestamp),
                        where("createdAt", "<", tomorrowTimestamp),
                        where("paymenttype", "==", "B"),
                        where("status", "==", "Working"),
                    )
                ),
                getDocs(
                    query(
                        collection(db, "bookingservices"),
                        where("uid", "==", userData.uid),
                        where("type", "==", "Booking"),
                        where("createdAt", ">=", todayTimestamp),
                        where("createdAt", "<", tomorrowTimestamp),
                    )
                )
            ]);

            if (userDocSnap.exists()) {
                setusername(userDocSnap.data().name);
                setloadincount(false);
            }

            // --- 3. PRE-FETCH LOOKUP DATA FOR PAY HISTORY ---
            const payHistoryDocs = payHistorySnapshot.docs;
            const bookingIdsToFetch = new Set(payHistoryDocs.map(doc => doc.data().bookingid).filter(id => id));
            const paymodeIdsToFetch = new Set();
            payHistoryDocs.forEach(doc => {
                const data = doc.data();
                if (data.paymode1) paymodeIdsToFetch.add(data.paymode1);
                if (data.paymode2) paymodeIdsToFetch.add(data.paymode2);
            });

            const [
                allPaymentModesSnapshot,
                bookingsLookupSnapshot
            ] = await Promise.all([
                getDocs(collection(db, "paymentmodes")),
                bookingIdsToFetch.size > 0 ? getDocs(query(collection(db, "reservations"), where('__name__', 'in', Array.from(bookingIdsToFetch)))) : { docs: [] }
            ]);

            const paymentModeLookup = allPaymentModesSnapshot.docs.reduce((acc, doc) => {
                acc[doc.id] = doc.data().paymode;
                return acc;
            }, {});
            const bookingDataLookup = bookingsLookupSnapshot.docs.reduce((acc, doc) => {
                acc[doc.id] = doc.data();
                return acc;
            }, {});

            // --- 4. PROCESS PAY HISTORY WITH LOOKUPS (FAST) ---
            const payHistoryData = payHistoryDocs.map((doc1) => {
                const docData = doc1.data();
                const paymode1 = paymentModeLookup[docData.paymode1] || "";
                const paymode2 = paymentModeLookup[docData.paymode2] || "";
                const date = docData.createdAt.toDate();
                const formattedDate = moment(date).format('DD-MM-YYYY HH:mm:ss');

                let bookingData = {};
                const bookingDocData = bookingDataLookup[docData.bookingid];

                if (bookingDocData) {
                    bookingData = {
                        rooms: bookingDocData.rooms || [],
                        checkinDate: bookingDocData.checkindate || null,
                        checkoutDate: bookingDocData.checkoutdate || null,
                        custName: bookingDocData.customers?.custname || ""
                    };
                }

                return {
                    id: doc1.id,
                    data: docData,
                    paymode1,
                    paymode2,
                    createdat: formattedDate,
                    bookingData
                };
            });
            setpayhistory(payHistoryData);

            // --- 5. CALCULATE PAYMENT MODE TOTALS (FAST) ---
            // Reuse paymentModeLookup for mode names
            const paymentModeTotals = allPaymentModesSnapshot.docs.map(modeDoc => {
                let total1 = 0;
                let total2 = 0;
                const paymodeId = modeDoc.id;

                payHistoryData.forEach(pay => {
                    if (pay.data.paymode1 === paymodeId) {
                        total1 += pay.data.amount1 || 0;
                    }
                    if (pay.data.paymode2 === paymodeId) {
                        total2 += pay.data.amount2 || 0;
                    }
                });

                return {
                    id: paymodeId,
                    paymode: paymentModeLookup[paymodeId] || "",
                    totalamount: (total1 + total2).toFixed(2)
                };
            });
            setpaymodes(paymentModeTotals);
            const totalAmount = paymentModeTotals.reduce((sum, data) => sum + parseFloat(data.totalamount), 0);
            settotal(totalAmount.toFixed(0));


            // --- 6. PROCESS BOOKING SERVICES ---
            const serviceData = servicesSnapshot.docs.map((doc) => {
                const data = doc.data();
                const createdAt = data.createdAt;
                const entryTime = createdAt ? createdAt.toDate() : null;
                const entryTimeFomat = moment(entryTime).format('DD-MM-YYYY hh:mm:ss A');
                return {
                    id: doc.id,
                    data: data,
                    entryTime: entryTimeFomat,
                };
            });
            setserviceData(serviceData);

            // --- 7. FETCH CHECKIN DETAILS & BOOKING DATA FOR REPORT ---
            const [checkinDetailsBookedSnapshot, checkinDetailsCheckoutSnapshot] =
                await Promise.all([
                    getDocs(
                        query(
                            collection(db, "checkindetails"),
                            where("status", "==", "Booked"),
                            where("uid", "==", userData.uid),
                            where("checkindate", "==", reportDate),
                            orderBy("createdAt", "asc") // ✅ ASCENDING
                        )
                    ),
                    getDocs(
                        query(
                            collection(db, "checkindetails"),
                            where("status", "==", "Checkout"),
                            where("uid", "==", userData.uid),
                            where("checkindate", "==", reportDate),
                            orderBy("createdAt", "asc") // ✅ ASCENDING
                        )
                    ),
                ]);


            const checkinDetailsData = [
                ...checkinDetailsCheckoutSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })),
                ...checkinDetailsBookedSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
            ];

            const uniqueCheckinDetails = Array.from(new Map(checkinDetailsData.map(item => [item.bookingid, item])).values());
            const reportBookingIds = uniqueCheckinDetails.map(doc => doc.bookingid).filter(id => id);
            
            if (reportBookingIds.length === 0) {
                setbookingData([]);
                return;
            }

            // --- 8. BULK FETCH BOOKINGS AND ORDERS FOR REPORT ---
            const [reportBookingsSnapshot, ordersSnapshot] = await Promise.all([
                getDocs(query(collection(db, 'reservations'), where('__name__', 'in', reportBookingIds))),
                getDocs(query(collection(db, 'orders'), where('status', '==', 'Bill Pending'), where('orderdate', '==', reportDate), where('bookingId', 'in', reportBookingIds)))
            ]);

            const bookingsDataMap = reportBookingsSnapshot.docs.reduce((acc, doc) => {
                acc[doc.id] = { id: doc.id, ...doc.data() };
                return acc;
            }, {});

            

            // Calculate total food amount per booking from the bulk order fetch
            const foodTotalsMap = ordersSnapshot.docs.reduce((acc, doc) => {
                const data = doc.data();
                const bookingId = data.bookingId;
                acc[bookingId] = (acc[bookingId] || 0) + (data.totalamount || 0);
                return acc;
            }, {});

            // Create a map of payment history by bookingId for the report
            const paymentHistoryMap = payHistoryData.reduce((acc, pay) => {
                const bookingId = pay.data.bookingid;
                if (bookingsDataMap[bookingId]) {
                    if (!acc[bookingId]) acc[bookingId] = [];
                    acc[bookingId].push(pay);
                }
                return acc;
            }, {});


            // --- 9. COMBINE DATA AND CALCULATE FINALS (FAST) ---
            let allllroomamount = 0;
            let allllfoodamount = 0;
            let alllltotalamount = 0;
            let allllalltoal = 0;
            let allllpaidamount = 0;
            let allllserviceamount = 0;
            let allllpending = 0;
            let noofroomscount = 0;
            let alladults = 0;
            let allchilds = 0;

            const combinedData = uniqueCheckinDetails.map((checkinDetail) => {
                const bookingData = bookingsDataMap[checkinDetail.bookingid];
                if (!bookingData) return null; // Skip if booking data wasn't found (shouldn't happen with the bulk fetch)

                const roomamount = bookingData.rooamount || 0;
                const date1 = moment(bookingData.checkindate, 'YYYY-MM-DD');
                const date2 = moment(reportDate, 'YYYY-MM-DD');

                let dayDifference = date2.diff(date1, 'days');
                if (dayDifference === 0) dayDifference = 1;

                const serviceamount = parseFloat(bookingData.serviceamount) / parseFloat(bookingData.noofdays) || 0;
                const foodTotal = foodTotalsMap[checkinDetail.bookingid] || 0; // FAST LOOKUP

                // Payment history calculation
                const paymentHistory = paymentHistoryMap[checkinDetail.bookingid] || [];
                const paidAmount = paymentHistory.reduce((sum, pay) => sum + pay.data.amount1 + pay.data.amount2, 0);

                const totalamount = parseFloat(roomamount) + parseFloat(serviceamount) + parseFloat(foodTotal);
                const alltoal = parseFloat(totalamount) * parseFloat(dayDifference);
                const remaining = parseFloat(alltoal) - parseFloat(paidAmount);

                // Tallying totals
                allllroomamount += parseFloat(roomamount);
                allllfoodamount += parseFloat(foodTotal);
                alllltotalamount += parseFloat(totalamount);
                allllalltoal += parseFloat(alltoal);
                allllpaidamount += parseFloat(paidAmount);
                allllserviceamount += parseFloat(serviceamount);
                allllpending += parseFloat(remaining);
                noofroomscount += parseFloat(bookingData.rooms.length);
                alladults += parseFloat(bookingData.adults);
                allchilds += parseFloat(bookingData.childs);

                return {
                    ...checkinDetail,
                    booking: bookingData,
                    serviceamount: serviceamount.toFixed(0),
                    roomamount: roomamount.toFixed(0),
                    foodamount: foodTotal.toFixed(0),
                    totalamount: totalamount.toFixed(0),
                    alltoal: alltoal.toFixed(0),
                    paidamount: paidAmount.toFixed(0),
                    pending: remaining.toFixed(0),
                    todayDays: dayDifference,
                    paymentHistory
                };
            }).filter(item => item !== null);

            // --- 10. FINAL STATE UPDATES ---
            setallllroomamount(allllroomamount.toFixed(0));
            setallllfoodamount(allllfoodamount.toFixed(0));
            setalllltotalamount(alllltotalamount.toFixed(0));
            setallllserviuceamount(allllserviceamount.toFixed(0));
            setroomscount(noofroomscount.toFixed(0));
            setallchilds(allchilds.toFixed(0));
            setalladults(alladults.toFixed(0));
            setbookingData(combinedData);

        } catch (error) {
            console.error("Error in fetchUsers:", error);
        }
    };

    const handlePrint = () => {
        window.print();
    };

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <div className="row print-area">
                            <div className="col-md-12">
                                <div className="card  card-outline" ref={printRef}>
                                    <div className="card-body">
                                        <Box p={1} mb={2}>
                                            <Grid className="row" alignItems="center">
                                                <Grid className="col-sm-12" textAlign="center">
                                                    <Typography variant="h5" fontWeight="bold"
                                                        style={{ textTransform: "uppercase", color: "red" }}>{propData.hotelname}</Typography>
                                                    <Typography variant="subtitle2">
                                                        GSTIN No - {propData.hotelname}
                                                    </Typography>
                                                    <Typography>
                                                        {propData.address} {propData.city} {propData.state} {propData.pincode}
                                                        <br />
                                                        Phone: +91 {propData.mobile} | Email: {propData.email}
                                                        <br />
                                                        {/* Website: {propData.website} */}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        <hr />
                                        <div className='row'>
                                            <TableContainer component={Paper} sx={{ mb: 2 }}>
                                                <Table>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell align="center" width="33%">
                                                                <Typography variant="body2">
                                                                    Report Date : {moment().format("DD-MM-YYYY HH:mm:ss A")}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell align="center" width="33%">
                                                                <Typography variant="h6" sx={{ textTransform: "uppercase" }}>
                                                                    Daily Report
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell align="center" width="33%">
                                                                <Typography variant="body2">
                                                                    Receptionist : {username}
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            {/* Booking Report */}
                                            <TableContainer component={Paper} sx={{ mb: 3 }}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell colSpan={11} sx={{ backgroundColor: "#E0FCFE" }} align="center">
                                                                <Typography variant="subtitle1">Booking Report</Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell>Sr No</TableCell>
                                                            <TableCell>Customer Name</TableCell>
                                                            <TableCell>Checkin</TableCell>
                                                            <TableCell>Checkout</TableCell>
                                                            <TableCell>Days</TableCell>
                                                            <TableCell>Rooms</TableCell>
                                                            <TableCell align="right">Persons</TableCell>
                                                            <TableCell align="right">Amount</TableCell>
                                                            <TableCell align="right">Extra</TableCell>
                                                            <TableCell align="right">Total</TableCell>
                                                            <TableCell align="center">Payments</TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {bookingData.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell sx={{ textTransform: "capitalize" }}>
                                                                    {item.booking.customers.custname}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {moment(item.checkindate).format("DD/MM/YYYY")} {item.checkintime}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {moment(item.checkoutdate).format("DD/MM/YYYY")} {item.checkouttime}
                                                                </TableCell>
                                                                <TableCell>1</TableCell>
                                                                <TableCell>
                                                                    {item.booking.rooms.map((r, i) => (
                                                                        <Typography key={i} variant="body2">
                                                                            {r.roomname} ({parseFloat(r.discount)}%)
                                                                        </Typography>
                                                                    ))}
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    {item.booking.adults} (A) / {item.booking.childs} (C)
                                                                </TableCell>
                                                                <TableCell align="right">{item.roomamount}</TableCell>
                                                                <TableCell align="right">{item.serviceamount}</TableCell>
                                                                <TableCell align="right">{item.totalamount}</TableCell>
                                                                <TableCell align="right">
                                                                    {item.paymentHistory.length > 0 ? (
                                                                        item.paymentHistory.map((p, i) => (
                                                                            <Box key={i}>
                                                                                {parseFloat(p.data.amount1) > 0 && (
                                                                                    <Typography fontWeight="bold">
                                                                                        {p.paymode1} : {parseFloat(p.data.amount1).toFixed(0)}
                                                                                    </Typography>
                                                                                )}
                                                                                {parseFloat(p.data.amount2) > 0 && (
                                                                                    <Typography fontWeight="bold">
                                                                                        {p.paymode2} : {parseFloat(p.data.amount2).toFixed(0)}
                                                                                    </Typography>
                                                                                )}
                                                                            </Box>
                                                                        ))
                                                                    ) : (
                                                                        <Typography color="error" fontWeight="bold">
                                                                            Pending
                                                                        </Typography>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}

                                                        {/* Total Row */}
                                                        <TableRow>
                                                            <TableCell colSpan={5} align="right" sx={{ fontWeight: "bold" }}>
                                                                TOTAL
                                                            </TableCell>
                                                            <TableCell>{roomscount}</TableCell>
                                                            <TableCell align="right">
                                                                {alladults} (A) / {allchilds} (C)
                                                            </TableCell>
                                                            <TableCell align="right">{allllroomamount}</TableCell>
                                                            <TableCell align="right">{allllserviuceamount}</TableCell>
                                                            <TableCell align="right">{alllltotalamount}</TableCell>
                                                            <TableCell />
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                            <TableContainer component={Paper} sx={{ mb: 3 }}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell
                                                                colSpan={12}
                                                                align="center"
                                                                sx={{ backgroundColor: "#E0FCFE" }}
                                                            >
                                                                <Typography variant="subtitle1">
                                                                    Collection Report
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell>Custname</TableCell>
                                                            <TableCell>Room</TableCell>
                                                            <TableCell>Checkin</TableCell>
                                                            <TableCell>Checkout</TableCell>
                                                            <TableCell>Paymode1</TableCell>
                                                            <TableCell>Amount1</TableCell>
                                                            <TableCell>Paynote1</TableCell>
                                                            <TableCell>Paymode2</TableCell>
                                                            <TableCell>Amount2</TableCell>
                                                            <TableCell>Paynote2</TableCell>
                                                            <TableCell>Datetime</TableCell>
                                                            <TableCell>Note</TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {payhistory.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell>{item.bookingData.custName}</TableCell>

                                                                <TableCell>
                                                                    {item.bookingData.rooms.map((room, i) => (
                                                                        <Typography key={i} variant="body2">
                                                                            {room.roomno}
                                                                        </Typography>
                                                                    ))}
                                                                </TableCell>

                                                                <TableCell>
                                                                    {moment(item.bookingData.checkinDate).format("DD-MM-YYYY")}
                                                                </TableCell>

                                                                <TableCell>
                                                                    {moment(item.bookingData.checkoutDate).format("DD-MM-YYYY")}
                                                                </TableCell>

                                                                <TableCell>{item.paymode1}</TableCell>
                                                                <TableCell>{item.data.amount1}</TableCell>
                                                                <TableCell>{item.data.paytime1}</TableCell>
                                                                <TableCell>{item.paymode2}</TableCell>
                                                                <TableCell>{item.data.amount2}</TableCell>
                                                                <TableCell>{item.data.paytime2}</TableCell>
                                                                <TableCell>{item.createdat}</TableCell>
                                                                <TableCell>{item.data.note}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                            <TableContainer component={Paper} sx={{ mb: 2 }}>
                                                <Table size="small" width="50%">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell
                                                                colSpan={paymodes.filter(p => p.totalamount > 0).length + 1}
                                                                align="center"
                                                                sx={{ backgroundColor: "#E0FCFE" }}
                                                            >
                                                                <Typography variant="subtitle1">
                                                                    Paymode Wise Collection
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell>Paymodes</TableCell>
                                                            {paymodes.map(
                                                                (item, index) =>
                                                                    item.totalamount > 0 && (
                                                                        <TableCell key={index} align="center">
                                                                            {item.paymode}
                                                                        </TableCell>
                                                                    )
                                                            )}
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell>Amount</TableCell>
                                                            {paymodes.map(
                                                                (item, index) =>
                                                                    item.totalamount > 0 && (
                                                                        <TableCell key={index} align="center">
                                                                            {item.totalamount}
                                                                        </TableCell>
                                                                    )
                                                            )}
                                                        </TableRow>
                                                    </TableHead>
                                                </Table>
                                            </TableContainer>

                                        </div>
                                    </div>

                                </div>
                                <center>
                                    <button className='btn btn-success' onClick={handlePrint}>Print Report</button>
                                </center>
                            </div>
                        </div>
                    </div>
                </section >
            </div>
        </div >

    )
}

export default Selfreport
